/* Equipment Buyback — quote builder.
 *
 * Model data is not duplicated here: it is read off the data attributes
 * that bb-quote.liquid renders from section blocks, so prices stay
 * editable in the theme editor and can never drift from the markup.
 *
 * Degradation: with JS off the grid still renders every model with its
 * credit value (a readable price list), the bulk form still works, and
 * the phone number is still there. Only the cart/quote flow needs script.
 */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-bb-quote]');

    // Both forms on this page post to /contact and Liquid cannot tell which
    // one came back, so each success panel is tagged and we keep only the
    // one matching the fragment Shopify returns us to.
    resolvePostedPanels();

    if (!root) return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-bb-model]'));
    if (!cards.length) return;

    var searchEl = root.querySelector('[data-bb-search]');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-bb-brand]'));
    var noResults = root.querySelector('[data-bb-no-results]');
    var linesEl = root.querySelector('[data-bb-lines]');
    var railEmpty = root.querySelector('[data-bb-rail-empty]');
    var totalWrap = root.querySelector('[data-bb-total-wrap]');
    var totalEl = root.querySelector('[data-bb-total]');
    var ctas = Array.prototype.slice.call(root.querySelectorAll('[data-bb-open]'));
    var sticky = root.querySelector('[data-bb-sticky]');
    var stickyCount = root.querySelector('[data-bb-sticky-count]');
    var stickyTotal = root.querySelector('[data-bb-sticky-total]');
    var modal = root.querySelector('[data-bb-modal]');
    var summaryEl = root.querySelector('[data-bb-summary]');
    var fieldItems = root.querySelector('[data-bb-field-items]');
    var fieldTotal = root.querySelector('[data-bb-field-total]');

    var cart = {};            // id -> qty
    var brand = '*';
    var query = '';
    var lastFocused = null;

    var byId = {};
    cards.forEach(function (card) {
      byId[card.dataset.id] = {
        el: card,
        id: card.dataset.id,
        name: card.dataset.name || '',
        brand: card.dataset.brand || '',
        credit: parseInt(card.dataset.credit, 10) || 0
      };
    });

    /* ---------- filtering ---------- */
    function applyFilter() {
      var shown = 0;
      cards.forEach(function (card) {
        var m = byId[card.dataset.id];
        var matchBrand = brand === '*' || m.brand === brand;
        var matchQuery = !query || m.name.toLowerCase().indexOf(query) !== -1;
        var visible = matchBrand && matchQuery;
        card.hidden = !visible;
        if (visible) shown++;
      });
      if (noResults) noResults.hidden = shown !== 0;
    }

    if (searchEl) {
      searchEl.addEventListener('input', function () {
        query = searchEl.value.trim().toLowerCase();
        applyFilter();
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        brand = tab.dataset.bbBrand;
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        applyFilter();
      });
      tab.setAttribute('aria-pressed', tab.classList.contains('is-active') ? 'true' : 'false');
    });

    /* ---------- cart ---------- */
    function setQty(id, qty) {
      qty = Math.max(0, Math.min(999, qty));
      if (qty === 0) delete cart[id];
      else cart[id] = qty;
      renderCard(id);
      renderRail();
    }

    function renderCard(id) {
      var m = byId[id];
      if (!m) return;
      var qty = cart[id] || 0;
      var addBtn = m.el.querySelector('[data-bb-add]');
      var stepper = m.el.querySelector('[data-bb-stepper]');
      var qtyEl = m.el.querySelector('[data-bb-qty]');
      if (qtyEl) qtyEl.textContent = String(qty);
      if (addBtn) addBtn.hidden = qty > 0;
      if (stepper) stepper.hidden = qty === 0;
      m.el.classList.toggle('is-added', qty > 0);
    }

    function lineItems() {
      return Object.keys(cart).map(function (id) {
        var m = byId[id];
        return { id: id, name: m.name, qty: cart[id], total: m.credit * cart[id] };
      }).sort(function (a, b) { return b.total - a.total; });
    }

    function renderRail() {
      var items = lineItems();
      var count = items.reduce(function (a, i) { return a + i.qty; }, 0);
      var total = items.reduce(function (a, i) { return a + i.total; }, 0);
      var has = items.length > 0;

      if (linesEl) {
        linesEl.hidden = !has;
        linesEl.textContent = '';
        items.forEach(function (i) {
          var li = document.createElement('li');
          li.className = 'bb-quote__line';

          var label = document.createElement('span');
          label.className = 'bb-quote__line-label';
          label.textContent = i.qty + '× ' + i.name;

          var amount = document.createElement('span');
          amount.className = 'bb-quote__line-amount';
          amount.textContent = '$' + i.total;

          var remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'bb-quote__line-remove';
          remove.setAttribute('aria-label', 'Remove ' + i.name);
          remove.textContent = '✕';
          remove.addEventListener('click', function () { setQty(i.id, 0); });

          li.appendChild(label);
          li.appendChild(amount);
          li.appendChild(remove);
          linesEl.appendChild(li);
        });
      }

      if (railEmpty) railEmpty.hidden = has;
      if (totalWrap) totalWrap.hidden = !has;
      if (totalEl) totalEl.textContent = String(total);

      ctas.forEach(function (btn) {
        btn.setAttribute('aria-disabled', has ? 'false' : 'true');
      });

      if (sticky) sticky.hidden = !has;
      if (stickyCount) stickyCount.textContent = count + (count === 1 ? ' item' : ' items');
      if (stickyTotal) stickyTotal.textContent = String(total);

      // Keep the hidden form fields in step with the cart so a submit that
      // bypasses the button (Enter key) still carries the itemisation.
      var summary = count + (count === 1 ? ' item' : ' items') + ' · up to $' + total + ' in credit';
      if (summaryEl) summaryEl.textContent = summary;
      if (fieldTotal) fieldTotal.value = '$' + total;
      if (fieldItems) {
        fieldItems.value = items.map(function (i) {
          return i.qty + ' x ' + i.name + ' (up to $' + i.total + ')';
        }).join('\n');
      }
    }

    cards.forEach(function (card) {
      var id = card.dataset.id;
      var add = card.querySelector('[data-bb-add]');
      var inc = card.querySelector('[data-bb-inc]');
      var dec = card.querySelector('[data-bb-dec]');
      if (add) add.addEventListener('click', function () { setQty(id, 1); });
      if (inc) inc.addEventListener('click', function () { setQty(id, (cart[id] || 0) + 1); });
      if (dec) dec.addEventListener('click', function () { setQty(id, (cart[id] || 0) - 1); });
      renderCard(id);
    });

    /* ---------- modal ---------- */
    function openModal() {
      if (!modal || !Object.keys(cart).length) return;
      lastFocused = document.activeElement;
      modal.hidden = false;
      document.documentElement.classList.add('bb-modal-open');
      var first = modal.querySelector('input:not([type="hidden"]), textarea, button');
      if (first) first.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      document.documentElement.classList.remove('bb-modal-open');
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') { closeModal(); return; }
      if (e.key !== 'Tab' || !modal) return;
      // Simple focus wrap so keyboard users cannot tab out of the dialog.
      var focusables = Array.prototype.slice.call(
        modal.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), textarea, select')
      ).filter(function (el) { return el.offsetParent !== null; });
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    ctas.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (btn.getAttribute('aria-disabled') === 'true') {
          e.preventDefault();
          var grid = root.querySelector('[data-bb-grid]');
          if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        openModal();
      });
    });

    root.querySelectorAll('[data-bb-close], [data-bb-close-backdrop]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    renderRail();
  }

  /* Keep only the success panel matching the fragment Shopify returned to. */
  function resolvePostedPanels() {
    var panels = Array.prototype.slice.call(document.querySelectorAll('[data-bb-posted]'));
    if (panels.length < 2) return;
    var hash = (window.location.hash || '').replace('#', '');
    if (!hash) return;
    panels.forEach(function (p) {
      if (p.dataset.bbPosted !== hash) p.remove();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
